module.exports = __webpack_public_path__ + "static/kakaobank_img01@2x-437b2f27c367390b21212743622db2ac.jpg";